<template>
  <div class="view-topic">
    <community-shell :community-id="$route.params.id" active="forum">
      <div class="topic-nav d-flex align-items-center">
        <button class="btn btn-back p-0 mr-3" @click="goBack">
          <i class="icon-chevron-left" />
        </button>
        <h5 class="topic-title mb-0">Tópico</h5>
      </div>

      <div v-if="loading" class="text-center py-5">
        <b-spinner variant="primary" />
      </div>

      <p v-else-if="!post" class="topic-missing mb-0">
        Este tópico não está mais disponível.
      </p>

      <post-card
        v-else
        :post="post"
        :can-moderate="canModerate"
        expanded
        @updated="post = $event"
        @deleted="goBack"
      />
    </community-shell>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommunityShell from "@/components/community/CommunityShell.vue";
import PostCard from "@/components/community/PostCard.vue";

export default {
  name: "TopicView",
  components: { CommunityShell, PostCard },
  data() {
    return {
      post: null,
      loading: true
    };
  },
  computed: {
    ...mapState("community", ["community"]),
    canModerate() {
      return !!(
        this.community &&
        this.community.id === this.$route.params.id &&
        this.community.can_moderate
      );
    }
  },
  watch: {
    "$route.params.postId": "fetch"
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$store
        .dispatch("community/getPost", this.$route.params.postId)
        .then(post => {
          this.post = post;
        })
        .catch(() => {
          this.post = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push({
        name: "community-forum",
        params: {
          id: this.$route.params.id,
          forumId: this.$route.params.forumId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-topic {
  .topic-nav {
    margin-bottom: 20px;

    .btn-back {
      border: none;
      background: transparent;
      color: inherit;

      i {
        font-size: 20px;
      }
    }

    .topic-title {
      font-size: 16px;
      font-weight: 600;
    }
  }

  .topic-missing {
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(128, 128, 128, 0.2);
    font-size: 14px;
    opacity: 0.8;
  }
}
</style>
